module.exports = __webpack_public_path__ + "img/bbdc-hero.dd28af6a.jpg";